<template>
  <div class="wrapper blog-post">
    <div class="page-header page-header-small">
      <parallax class="page-header-image" style="background-image: url('img/bg24.jpg')"></parallax>
      <div class="content-center">
        <div class="row">
          <div class="col-md-8 ml-auto mr-auto text-center">
            <h2 class="title">Preguntas frecuentes</h2>
          </div>
        </div>
      </div>
    </div>
    <div class="main container-fluid">
        <!--
         <div class="card-collapse accordion" id="accordionExample" role="tablist">
        <div class="card">
            <div class="card-header" id="headingOne">
                <h2 class="mb-0">
                    <button type="button" class="btn btn-link" data-toggle="collapse" data-target="#collapseOne">1. What is HTML?</button>									
                </h2>
            </div>
            <div id="collapseOne" class="collapse" aria-labelledby="headingOne" data-parent="#accordionExample">
                <div class="card-body">
                    <p>HTML stands for HyperText Markup Language. HTML is the standard markup language for describing the structure of web pages. <a href="https://www.tutorialrepublic.com/html-tutorial/" target="_blank">Learn more.</a></p>
                </div>
            </div>
        </div>
        <div class="card">
            <div class="card-header" id="headingTwo">
                <h2 class="mb-0">
                    <button type="button" class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseTwo">2. What is Bootstrap?</button>
                </h2>
            </div>
            <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo" data-parent="#accordionExample">
                <div class="card-body">
                    <p>Bootstrap is a sleek, intuitive, and powerful front-end framework for faster and easier web development. It is a collection of CSS and HTML conventions. <a href="https://www.tutorialrepublic.com/twitter-bootstrap-tutorial/" target="_blank">Learn more.</a></p>
                </div>
            </div>
        </div>
        <div class="card">
            <div class="card-header" id="headingThree">
                <h2 class="mb-0">
                    <button type="button" class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseThree">3. What is CSS?</button>                     
                </h2>
            </div>
            <div id="collapseThree" class="collapse" aria-labelledby="headingThree" data-parent="#accordionExample">
                <div class="card-body">
                    <p>CSS stands for Cascading Style Sheet. CSS allows you to specify various style properties for a given HTML element such as colors, backgrounds, fonts etc. <a href="https://www.tutorialrepublic.com/css-tutorial/" target="_blank">Learn more.</a></p>
                </div>
            </div>
        </div>
    </div>
    -->
       <collapse style="margin-top:30px;">
  
            <collapse-item title="¿Dónde llamo si tengo una Urgencia Médica?"  class="pregunta" > 
                     
                <div class="respuesta">
                    <p>
                      En esta WEB tenes los números de teléfono para cada situación: Urgencia, Derivación, Atención al afiliado. Además dichos teléfonos estan disponibles en nuestra APP.
                    </p>
                </div>
            </collapse-item>
             <collapse-item title="¿Cómo tramito una autorización?"  class="pregunta" > 
                     
                <div class="respuesta">
                    <p>
                     Podés tramitar las autorizaciones de prácticas enviando la receta médica al mail de tu seccional o desde la autogestión de este sitio ingresando con tu usuario, seleccionas el trámite, adjuntas la receta y enviás. Podes hacer el seguimiento de tu autorización desde esta página y descargarla cuando esté lista.

                    </p>
                </div>
            </collapse-item>
            <collapse-item title="¿Como obtengo mi credencial?"  class="pregunta" > 
                     
                <div class="respuesta">
                    <p>
                        Ingresando con  tu usuario podés generar tu credencial digital.También desde la APP.
                    </p>
                </div>
            </collapse-item>
             <collapse-item title="¿Hay atención presencial en las Seccionales?"  class="pregunta" > 
                     
                <div class="respuesta">
                    <p>
                       Debido al contexto que estamos atravesando te sugerimos usar los canales digitales.
                       Si es imprescindible que concurras a nuestras oficinas contactate via mail o telefónicamente y solicitá un turno.
                       Es una forma de cuidarnos entre todos.

                    </p>
                </div>
            </collapse-item>
             <collapse-item title="¿Ante síntomas o sospecha de Covid cómo debo proceder?"  class="pregunta" > 
                     
                <div class="respuesta">
                    <p>
                     Ante síntomas o sospecha de Covid en principio mantenete aislado y avisa a todos tus contactos estrechos.
                     Podes acudir a la Guardia más cercana o bien solicitar médico a domicilio (tené en cuenta que hay demoras).
                     Será el Profesional de Salud quien te indique los pasos a seguir.
                     En el caso de efectuarte un hisopado y su resultado sea positivo deberás contactarte con nuestra Obra Social para hacer el seguimiento.
                    </p>
                </div>
            </collapse-item>
        </collapse>

    </div>
  </div>
</template>


  

<script>



import { Collapse,CollapseItem } from "@/components";

export default {
  components: {
    Collapse,
    CollapseItem
  }
 
};
</script>
<style>

.pregunta{
    font-size: 20px;
    font-weight: 400;
}

.respuesta{
    font-size: 17px;
    font-weight: 300; 
    background: #efefef;
    padding:  1rem;
}
</style>
